<mat-card class="datatables-block" *ngIf="invest">
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'invest.eval.title.shortLabel' | translate}}
                <app-tooltip [text]="'invest.eval.title.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <app-sic-eval *ngIf="invest.simulation.provider !== providerType.bbc" [invest]="invest"></app-sic-eval>
        <app-bbc-eval *ngIf="invest.simulation.provider === providerType.bbc" [invest]="invest"></app-bbc-eval>
    </mat-card-content>

    <mat-card-actions>
        <ng-container *ngIf="!isProcessing">
            <button mat-raised-button color="accent" class="save-btn"
                [matTooltip]="'invest.eval.save.summary' | translate"
                (click)="onSave()" *ngIf="provider === 'bbc2020'">
                <mat-icon aria-label="Save">save</mat-icon>
                {{ 'invest.eval.save.shortLabel' | translate }}
            </button>
            <button mat-raised-button color="accent" class="save-btn"
                [matTooltip]="'invest.eval.saveSic.summary' | translate"
                (click)="onSave()" *ngIf="provider !== 'bbc2020'">
                <mat-icon aria-label="SaveSic">save</mat-icon>
                {{ 'invest.eval.saveSic.shortLabel' | translate }}
            </button>
            <button mat-raised-button color="accent" class="save-btn"
                [matTooltip]="'invest.eval.update.summary' | translate"
                *ngIf="invest.isEditable"
                (click)="onSave(true)">
                <mat-icon aria-label="Edit">edit</mat-icon>
                {{ 'invest.eval.update.shortLabel' | translate }}
            </button>
            <button mat-raised-button color="accent" class="export-btn"
                [matTooltip]="'reports.exports.xls.summary' | translate"
                (click)="onExport()">
                <mat-icon aria-label="File">insert_drive_file</mat-icon>
                {{ 'reports.exports.xls.shortLabel' | translate }}
            </button>
        </ng-container>
        <mat-spinner *ngIf="isProcessing" [diameter]="35" color="accent"></mat-spinner>
    </mat-card-actions>
</mat-card>
